module.exports = __webpack_public_path__ + "img/36221-008.574052ad.jpg";